import React from 'react';
import styles from './styles.module.scss';

function SocialBoxItem(props) {
	return (
		<a
			className={`${styles.socialIcons} ${props.className}`}
			href={props.link}
			rel='noopener noreferrer'
			target='_blank'
		>
			<i className={`social-icon fab fa-${props.icon} fa-2x`}></i>
		</a>
	);
}

export default SocialBoxItem;
